<h2>Settings</h2>
<button pButton pRipple label="Manage Credit Card" class="primary-button" [routerLink]="'/' + routes.CUSTOMER + '/' + routes.MANAGE_CREDIT_CARD"></button>
